import React from 'react';
import {observer} from 'mobx-react-lite';
import {Approval} from '../../../Core/mobx/ParameterStore/Approval';
import {CategoryCard} from '../CategoryCard';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {Grid} from '@material-ui/core';
import {TextBox} from '../../../Core/UI';

type MovingViolationsProps = {
    parameters: Approval;
    valueChanged: (p?: Parameter, value?: any) => void;
    setCategory: (entry: string) => void;
    index: number;
};

const MovingViolations = observer(({parameters, valueChanged, setCategory, index}: MovingViolationsProps) => {
    return (
        <CategoryCard title={'Moving violations'} setCategory={setCategory} index={index}>
            <Grid item xs={4}>
                <TextBox
                    id="violationNumbers"
                    label="How many moving violations did you have in the last 3 years?"
                    type="number"
                    value={parameters.violationNumbers?.value}
                    onChange={(value) => valueChanged(parameters.violationNumbers, value)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="movingViolationsNotes"
                    label="Notes"
                    value={parameters.movingViolationsNotes?.value}
                    onChange={(value) => valueChanged(parameters.movingViolationsNotes, value)}
                />
            </Grid>
        </CategoryCard>
    );
});

export default MovingViolations;
